import { PageContainer } from "@/components/layout/PageContainer";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { PaymentSlipList } from "./PaymentSlipList";

const STATUS_TABS = [
  { value: "Pending", label: "Pending" },
  { value: "Uploaded", label: "Uploaded" },
  { value: "all", label: "All" },
  { value: "Verified", label: "Verified" },
  { value: "Rejected", label: "Rejected" },
] as const;

export function PaymentSlipsPage() {
  return (
    <PageContainer>
      <div className="p-6 space-y-6">
        <div>
          <h2 className="text-2xl font-semibold">Payment Slips</h2>
          <p className="text-sm text-muted-foreground">
            Review and verify customer payment slips
          </p>
        </div>

        <Tabs defaultValue="Pending">
          <TabsList>
            {STATUS_TABS.map((tab) => (
              <TabsTrigger key={tab.value} value={tab.value}>
                {tab.label}
              </TabsTrigger>
            ))}
          </TabsList>

          {STATUS_TABS.map((tab) => (
            <TabsContent key={tab.value} value={tab.value}>
              <PaymentSlipList
                statusFilter={tab.value === "all" ? undefined : tab.value}
              />
            </TabsContent>
          ))}
        </Tabs>
      </div>
    </PageContainer>
  );
}
